import React from 'react';
import { trackEvent } from '../../api/tracker';

/**
 * The six programme cards. Clicking one preselects that track in the
 * application form and scrolls to it, so the visitor never has to re-choose.
 */
export default function ProgramTracks({ tracks = [], onSelect }) {
  const choose = (track) => {
    trackEvent('cta_click', {
      label: `track:${track.slug}`,
      page: 'training-internship',
    });
    onSelect?.(track.slug);

    const form = document.getElementById('apply');
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="sp-section" id="tracks">
      <div className="container">
        <div className="row">
          <div className="col-lg-8">
            <span className="sp-eyebrow">Six tracks</span>
            <h2 className="sp-heading">Pick the work you want to be doing</h2>
            <p className="sp-lead" style={{ marginBottom: '46px' }}>
              Each track sits inside a team that has real deadlines. You are given a scope of work
              on day one, a mentor who reviews it, and a deliverable that ships. No shadowing for
              twelve weeks.
            </p>
          </div>
        </div>

        <div className="row g-4">
          {tracks.map((track) => (
            <div className="col-lg-4 col-md-6" key={track.slug}>
              <article className="sp-track">
                <div className="sp-track__media">
                  <img
                    src={track.image_url}
                    alt={track.title}
                    loading="lazy"
                    onError={(e) => { e.currentTarget.src = '/assets/images/about/about-1.jpg'; }}
                  />
                  {track.seats > 0 && (
                    <span className="sp-track__seats">{track.seats} seats</span>
                  )}
                </div>

                <div className="sp-track__body">
                  <h3 className="sp-track__title">{track.title}</h3>
                  <p className="sp-track__tagline">{track.tagline}</p>
                  <p className="sp-track__text">{track.description}</p>

                  <div className="sp-track__meta">
                    <span><i className="fa-regular fa-clock" aria-hidden="true" /> {track.duration}</span>
                    <span><i className="fa-regular fa-location-dot" aria-hidden="true" /> {track.mode}</span>
                  </div>

                  {track.stipend && (
                    <p className="sp-track__meta" style={{ border: 0, padding: 0, marginBottom: 14 }}>
                      {/* Not an advertised amount: whether a placement is paid is
                          settled per candidate once the interviews are done. */}
                      <span><i className="fa-regular fa-circle-info" aria-hidden="true" /> Stipend: {track.stipend}</span>
                    </p>
                  )}

                  <div className="sp-chips">
                    {(track.skills || []).slice(0, 4).map((skill) => (
                      <span className="sp-chip" key={skill}>{skill}</span>
                    ))}
                    {(track.skills || []).length > 4 && (
                      <span className="sp-chip">+{track.skills.length - 4}</span>
                    )}
                  </div>

                  <button
                    type="button"
                    className="sp-btn sp-btn--primary"
                    style={{ width: '100%', justifyContent: 'center' }}
                    onClick={() => choose(track)}
                  >
                    Apply for this track
                    <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                  </button>
                </div>
              </article>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
